import common from "@page/common/js/common";
// var object = require('lodash/fp/object');

import IGapp from "@global/components/igtag/index";
import share from "@global/components/global/share";

const app = new Vue(
	Object.assign(
		{
			el: "#IGtag",
		},
		IGapp
	)
);
